import { StatusPill } from '@euler/components/StatusPill';
import { useResponsiveContext } from '@euler/functions/responsive/ResponsiveContext';
import { memo } from 'react';
import { View } from 'react-native';

/**
 * What the follow-up asks of the staff member (the payload's message, e.g.
 * 客户需要您人工回复) and why it came (客户咨询活动).
 */
export const FollowupStatus = memo(
  ({ message, why }: { message: string; why: string | null }) => {
    const { rpx } = useResponsiveContext();
    return (
      <View
        style={{
          flexDirection: 'row',
          flexWrap: 'wrap',
          gap: rpx(6),
          marginTop: rpx(8),
        }}
      >
        <StatusPill label={message} tone="active" />
        {why ? <StatusPill label={why} tone="neutral" /> : null}
      </View>
    );
  },
);
